
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import RadioButton from '@/components/radio-button.vue';
  import material from "./materialcomponents/material.vue"
  import grassshow from "./materialcomponents/grassshow.vue"
  import groupnotes from "./materialcomponents/groupnotes.vue"
  @Component({  
    name: '',
    components: {
      PageFooter,
      RadioButton,
      material,
      grassshow,
      groupnotes
    }
  })

  export default class ProductList extends Vue {
    private radioList = [
      {
				label: '发圈素材',
				value: 1
			}, {
				label: '种草秀',
				value: 2
			}, {
				label: '团品笔记',
				value: 3
			}
    ]
    private radioType = 1


    private handleChange(e){

    }

  }
